import { connect } from "react-redux";
import _ from "underscore";
import { RUBRIC_METRICS, consolidateMonthlyRubrics, getEntityName, calculateRubricScore } from "./GraphUtility";
import { providePopulateData } from "components/utility/hoc/PopulateData";
var {STAT_DISPLAY} = require("components/data/graphs/GraphUtility")

var DataSelectors = require("lib/selectors/DataSelectors")
var DataActions = require("lib/actions/DataActions");
var Spinner = require("components/utility/Spinner");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var Glyphicon = require("components/utility/icons/Glyphicon");

require("data/graphs/rubric_radar_graph.scss")

const METRIC_NUM = 6

@connect(
	(state, props) => {
        var downProps = {}
        var entityDigests = DataSelectors.digests({ state, filters: {entity_id: props.entity.id, entity_type: props.entityType, graph: true} })
        downProps.entityDigest = consolidateMonthlyRubrics(entityDigests)
        return downProps
    },
	(dispatch, props) => {
        var fetchDigests = (entityType, entity) => {
            if (!entityType || !entity) { return }
            
            var entityID = entity.id
            var conditions = {entityType: entityType, entityID: entityID }
            return dispatch(DataActions.fetchDigests({
                conditions: conditions,
                query: {digest_summary: true, graph_digests_only: true},
                cache: false
            }))
        }

        var populateData = () => {
            return Promise.all([
				fetchDigests(props.entityType, props.entity),
                fetchDigests(props.comparisonType, props.comparison)
			])
        }

        return {
            fetchDigests,
            populateData
        }
    }
)
@providePopulateData({waitForLoad: true})
class RubricRadarGraph extends React.Component {
	constructor(props) {
		super();
		autobind(this);

        var starterComparison = null
        if(props.comparisons && props.comparisons.length > 0) {
            starterComparison = props.comparisons[0]
        }

        this.state = {
            metrics: RUBRIC_METRICS.slice(0, METRIC_NUM ), //take the first six
            loadingDigests: false,
            loadedDependencies: false,
            activeComparison: starterComparison
        }
    }

    createData(){
        var data = []
        var entityKey = `${this.props.entity.id}-${this.props.entityType}`
        
        if (this.state.activeComparison){
            var comparisonKey = `${this.state.activeComparison.id}-${this.props.comparisonType}`
        }

        this.state.metrics.forEach(metric=>{
            var rubricPerformance = {}
            rubricPerformance.rubric = STAT_DISPLAY[metric].name
            rubricPerformance[entityKey] = calculateRubricScore(this.props.entityDigest, metric)
            rubricPerformance.fullMark = 100

            if (this.state.activeComparison){
                rubricPerformance[comparisonKey] = calculateRubricScore(this.state.comparisonDigest, metric)
            }
            data.push(rubricPerformance)
        })

        return data
    }

    changeMetric(metric){
        if (this.state.metrics.includes(metric)) { return }
        var oldMetrics = [...this.state.metrics]
        var newMetrics = oldMetrics.slice(1, METRIC_NUM)
        newMetrics.push(metric)
        this.setState({metrics: newMetrics})
    }

    changeComparison(newEntity){
        if (_.isEqual(this.state.activeComparison, newEntity)){ return }
        this.setState({activeComparison: newEntity})
    }

    renderControls(){
        var activityOptions = _.map(RUBRIC_METRICS, metric=>{
            var isSelected = this.state.metrics.includes(metric)
            
            return (
                <ButtonDropdownOption onClick={this.changeMetric.bind(this, metric)}>
                    <div className='dropdownText'>
                        <div className='checkContainer'>
                            {isSelected && <Glyphicon icon="check" />}
                        </div>
                        <div className='metricNameContainer'>
                            {STAT_DISPLAY[metric].name}
                        </div>
                    </div>
                </ButtonDropdownOption>
            )
        })

        var select = (
            <ButtonDropdown wide text='select skillsets' dropdownDisplay="link">
                {activityOptions}
            </ButtonDropdown>
        )
        
        var entityName = getEntityName(this.props.entityType, this.props.entity)

        if (this.state.activeComparison){
            var comparisonName = getEntityName(this.props.comparisonType, this.state.activeComparison)
            var divider = "|"
        }
        
        // only add comparison dropdown if there is more than one comparison to choose from
        if (this.props.comparisons && this.props.comparisons.length > 1){
            var comparisonOptions = this.props.comparisons.map(comparison=>{
                var isSelected = _.isEqual(comparison, this.state.activeComparison)
    
                return (
                    <ButtonDropdownOption onClick={this.changeComparison.bind(this, comparison)}>                    
                        <div className='dropdownText'>
                            <div className='checkContainer'>
                                {isSelected && <Glyphicon icon="check" />}
                            </div>
                            <div className='metricNameContainer'>
                                {getEntityName(this.props.comparisonType, comparison)}
                            </div>
                        </div>
                    </ButtonDropdownOption>
                )

                
            })

            var comparisonDropdown = (
                <ButtonDropdown text={comparisonName} dropdownDisplay="link">
                    {comparisonOptions}
                </ButtonDropdown>
            )

            var comparisonContent = (
                <span>
                    Benchmark: {comparisonDropdown}
                </span>
            )

            var tooltipText = `Compare the performance of ${entityName} to other classes. Select different skillsets to explore each class's unique strengths & weaknesses.`
            var toolTip = <Glyphicon icon='question-sign' dataTip={tooltipText}/>
        } else if (this.props.comparisons && this.props.comparisons.length == 1){ 
            // if only 1 comparison.
            var comparisonContent = (
                <span className='benchmarkDescription'>
                    Benchmark: <i>{comparisonName}</i>
                </span>
            )

            var tooltipText = `Compare the performance of ${entityName} to their primary class's averages. Select different skillsets to explore the student's unique strengths & weaknesses.`
            var toolTip = <Glyphicon icon='question-sign' dataTip={tooltipText}/>
        }


        return (
            <div className='controlDiv'>
                {comparisonContent}
                {divider}
                {select}
                {toolTip}
            </div>
        )
    }

    render(){
        if (this.state.loadingDigests) { 
            return (
                <div className='RubricRadarGraph'>
                    <Spinner/>
                </div>
            )
        }
        var entityKey = `${this.props.entity.id}-${this.props.entityType}`
        if (this.state.activeComparison){
            var comparisonKey = `${this.state.activeComparison.id}-${this.props.comparisonType}`
        }
        var data = this.createData()
        return (
            <div className='RubricRadarGraph'>
                {this.renderControls()}
                <Recharts.RadarChart outerRadius={95} width={730} height={300} data={data}>
                    <Recharts.PolarGrid />
                    <Recharts.PolarAngleAxis key={Math.random()} dataKey="rubric" />
                    <Recharts.PolarRadiusAxis angle={30} domain={[0, 100]}/>
                    <Recharts.Radar name={getEntityName(this.props.entityType, this.props.entity)} dataKey={entityKey} stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
                    {/* add comparison only if there is a comparison */}
                    {comparisonKey && <Recharts.Radar name={getEntityName(this.props.comparisonType, this.state.activeComparison)} dataKey={comparisonKey} stroke="#82ca9d" fill="#82ca9d" fillOpacity={0.6}/>}
                    <Recharts.Legend />
                </Recharts.RadarChart>
            </div>
        )
    }

    fetchComparisonData(){
        if (!this.state.activeComparison){ return }

        this.setState({loadingDigests: true})
        this.props.fetchDigests(this.props.comparisonType, this.state.activeComparison).then(res=>{
            var consolidatedDigests = consolidateMonthlyRubrics(res.digests)
            this.setState({comparisonDigest: consolidatedDigests, loadingDigests: false})
        })
    }

    componentDidUpdate(prevProps, prevState){
        if (prevState.activeComparison != this.state.activeComparison){
            this.fetchComparisonData()
        }
    }



    componentDidMount(){
        this.fetchComparisonData()
        $wr.loadScript("/dependencies/recharts.min.js", "Recharts", () => {
			this.setState({ loadedDependencies: true });
		});
    }
}

RubricRadarGraph.propTypes = PageStrictPropTypes({
    entity: PropTypes.object,
    entityType: PropTypes.string,
    metrics: PropTypes.array
});

module.exports = RubricRadarGraph


// WEBPACK FOOTER //
// ./modules/components/data/graphs/RubricRadarGraph.js